import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import FeaturedRoaster from "./sections/FeaturedRoaster";
import TopRoastersRatingTable from "./sections/TopRoastersRatingTable";
import LatestRoasterPosts from "./sections/LatestRoasterPosts";
import CallToAction from "./sections/CallToAction";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <FeaturedRoaster />
      <TopRoastersRatingTable />
      <LatestRoasterPosts />
      <CallToAction />
      <Footer />
    </div>;
}